import script from "./StatsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsView.vue?vue&type=script&setup=true&lang=js"

import "./StatsView.vue?vue&type=style&index=0&id=0433f693&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0433f693"]])

export default __exports__